import { render, staticRenderFns } from "./VisitorCreate.vue?vue&type=template&id=2c9c4b03&scoped=true&"
import script from "./VisitorCreate.vue?vue&type=script&lang=js&"
export * from "./VisitorCreate.vue?vue&type=script&lang=js&"
import style0 from "./VisitorCreate.vue?vue&type=style&index=0&id=2c9c4b03&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9c4b03",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDatePicker,VForm,VIcon,VImg,VRadio,VRadioGroup,VSelect,VTextField})
